// BV Agregar en un toque: formularios con data-bv-quick-add (carrito lateral y upsell).
// Modo normal: agrega la variante del campo name="id".
// Modo cambio (data-bv-swap='{"idViejo":0,"idNuevo":1}'): reemplaza una linea por otra, p. ej. Combo BV -> Combo PRO.
// Avisa al tema con el mismo evento que usa el boton de compra, asi el carrito se actualiza solo.
// Si algo falla, el formulario se envia normal.
import { CartLinesUpdateEvent } from '@shopify/events';

const SELECTOR = 'form[data-bv-quick-add]';

function route(name, fallback) {
  return (window.Theme && window.Theme.routes && window.Theme.routes[name]) || fallback;
}

async function refreshCart() {
  const comp = document.querySelector('cart-items-component');
  if (comp && typeof comp.fetchCartData === 'function') {
    await customElements.whenDefined('cart-items-component');
    return comp.fetchCartData();
  }
  const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return r.json();
}

async function quickAdd(form) {
  if (form.dataset.busy === 'true') return;
  const button = form.querySelector('button[type="submit"]');
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean)
    .join(',');

  let url;
  let payload;
  let lines;
  let action = 'add';
  let context = 'product';

  if (form.dataset.bvSwap) {
    let updates;
    try { updates = JSON.parse(form.dataset.bvSwap); } catch (e) { return; }
    url = route('cart_update_url', '/cart/update') + '.js';
    payload = { updates, sections: sectionIds };
    lines = Object.entries(updates).map(([id, quantity]) => ({ merchandiseId: id, quantity: Number(quantity) }));
    action = 'update';
    context = 'cart';
  } else {
    const field = form.querySelector('[name="id"]');
    const id = field ? String(field.value) : '';
    if (!id) return;
    url = route('cart_add_url', '/cart/add');
    payload = { items: [{ id: Number(id), quantity: 1 }], sections: sectionIds };
    lines = [{ merchandiseId: id, quantity: 1 }];
  }

  form.dataset.busy = 'true';
  const label = button ? button.textContent : '';
  if (button) { button.disabled = true; button.textContent = 'Un momento...'; }

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({ action, context, lines, promise: deferred.promise }));

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    const failed = !res.ok || Boolean(data && data.status);
    const cart = await refreshCart();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'bv-quick-add',
        sourceId: 'bv-quick-add',
        itemCount: 1,
        sections: failed ? undefined : data.sections,
        didError: failed,
      },
    });
    if (button && button.isConnected) {
      button.textContent = failed ? 'Sin stock' : 'Listo';
      setTimeout(() => { button.textContent = label; button.disabled = false; }, failed ? 2500 : 1500);
    }
  } catch (error) {
    deferred.reject(error);
    window.location.href = route('cart_url', '/cart');
  } finally {
    form.dataset.busy = 'false';
  }
}

if (!window.__bvQuickAdd) {
  window.__bvQuickAdd = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(SELECTOR)) return;
    event.preventDefault();
    quickAdd(form);
  }, true);
}
